import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import _regeneratorRuntime from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import { w as writeTask, B as Build } from './index-2cd7e630.js';
var LIFECYCLE_WILL_ENTER = 'ionViewWillEnter';
var LIFECYCLE_DID_ENTER = 'ionViewDidEnter';
var LIFECYCLE_WILL_LEAVE = 'ionViewWillLeave';
var LIFECYCLE_DID_LEAVE = 'ionViewDidLeave';
var LIFECYCLE_WILL_UNLOAD = 'ionViewWillUnload';

var iosTransitionAnimation = function iosTransitionAnimation() {
  return import('./ios.transition-11c6a0fa.js');
};

var mdTransitionAnimation = function mdTransitionAnimation() {
  return import('./md.transition-3e9127c1.js');
};

var transition = function transition(opts) {
  return new Promise(function (resolve, reject) {
    writeTask(function () {
      beforeTransition(opts);
      runTransition(opts).then(function (result) {
        if (result.animation) {
          result.animation.destroy();
        }

        afterTransition(opts);
        resolve(result);
      }, function (error) {
        afterTransition(opts);
        reject(error);
      });
    });
  });
};

var beforeTransition = function beforeTransition(opts) {
  var enteringEl = opts.enteringEl;
  var leavingEl = opts.leavingEl;
  setZIndex(enteringEl, leavingEl, opts.direction);

  if (opts.showGoBack) {
    enteringEl.classList.add('can-go-back');
  } else {
    enteringEl.classList.remove('can-go-back');
  }

  setPageHidden(enteringEl, false);

  if (leavingEl) {
    setPageHidden(leavingEl, false);
  }
};

var runTransition = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
    var animationBuilder, ani;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAnimationBuilder(opts);

          case 2:
            animationBuilder = _context.sent;
            ani = animationBuilder && Build.isBrowser ? animation(animationBuilder, opts) : noAnimation(opts); // fast path for no animation

            return _context.abrupt("return", ani);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function runTransition(_x) {
    return _ref.apply(this, arguments);
  };
}();

var afterTransition = function afterTransition(opts) {
  var enteringEl = opts.enteringEl;
  var leavingEl = opts.leavingEl;
  enteringEl.classList.remove('ion-page-invisible');

  if (leavingEl !== undefined) {
    leavingEl.classList.remove('ion-page-invisible');
  }
};

var getAnimationBuilder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
    var getAnimation;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!opts.leavingEl || !opts.animated || opts.duration === 0)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", undefined);

          case 2:
            if (!opts.animationBuilder) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", opts.animationBuilder);

          case 4:
            if (!(opts.mode === 'ios')) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return iosTransitionAnimation();

          case 7:
            _context2.t0 = _context2.sent.iosTransitionAnimation;
            _context2.next = 13;
            break;

          case 10:
            _context2.next = 12;
            return mdTransitionAnimation();

          case 12:
            _context2.t0 = _context2.sent.mdTransitionAnimation;

          case 13:
            getAnimation = _context2.t0;
            return _context2.abrupt("return", getAnimation);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getAnimationBuilder(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var animation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(animationBuilder, opts) {
    var trans, didComplete;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return waitForReady(opts, true);

          case 2:
            trans = animationBuilder(opts.baseEl, opts);
            fireWillEvents(opts.enteringEl, opts.leavingEl);
            _context3.next = 6;
            return playTransition(trans, opts);

          case 6:
            didComplete = _context3.sent;

            if (opts.progressCallback) {
              opts.progressCallback(undefined);
            }

            if (didComplete) {
              fireDidEvents(opts.enteringEl, opts.leavingEl);
            }

            return _context3.abrupt("return", {
              hasCompleted: didComplete,
              animation: trans
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function animation(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

var noAnimation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(opts) {
    var enteringEl, leavingEl;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            enteringEl = opts.enteringEl;
            leavingEl = opts.leavingEl;
            _context4.next = 4;
            return waitForReady(opts, false);

          case 4:
            fireWillEvents(enteringEl, leavingEl);
            fireDidEvents(enteringEl, leavingEl);
            return _context4.abrupt("return", {
              hasCompleted: true
            });

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function noAnimation(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

var waitForReady = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(opts, defaultDeep) {
    var deep, promises;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            deep = opts.deepWait !== undefined ? opts.deepWait : defaultDeep;
            promises = deep ? [deepReady(opts.enteringEl), deepReady(opts.leavingEl)] : [shallowReady(opts.enteringEl), shallowReady(opts.leavingEl)];
            _context5.next = 4;
            return Promise.all(promises);

          case 4:
            _context5.next = 6;
            return notifyViewReady(opts.viewIsReady, opts.enteringEl);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function waitForReady(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var notifyViewReady = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(viewIsReady, enteringEl) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!viewIsReady) {
              _context6.next = 3;
              break;
            }

            _context6.next = 3;
            return viewIsReady(enteringEl);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function notifyViewReady(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

var playTransition = function playTransition(trans, opts) {
  var progressCallback = opts.progressCallback;
  var promise = new Promise(function (resolve) {
    trans.onFinish(function (currentStep) {
      return resolve(currentStep === 1);
    });
  }); // cool, let's do this, start the transition

  if (progressCallback) {
    // this is a swipe to go back, just get the transition progress ready
    // kick off the swipe animation start
    trans.progressStart(true);
    progressCallback(trans);
  } else {
    // only the top level transition should actually start "play"
    // kick it off and let it play through
    // ******** DOM WRITE ****************
    trans.play();
  } // create a callback for when the animation is done


  return promise;
};

var fireWillEvents = function fireWillEvents(enteringEl, leavingEl) {
  lifecycle(leavingEl, LIFECYCLE_WILL_LEAVE);
  lifecycle(enteringEl, LIFECYCLE_WILL_ENTER);
};

var fireDidEvents = function fireDidEvents(enteringEl, leavingEl) {
  lifecycle(enteringEl, LIFECYCLE_DID_ENTER);
  lifecycle(leavingEl, LIFECYCLE_DID_LEAVE);
};

var lifecycle = function lifecycle(el, eventName) {
  if (el) {
    var ev = new CustomEvent(eventName, {
      bubbles: false,
      cancelable: false
    });
    el.dispatchEvent(ev);
  }
};

var shallowReady = function shallowReady(el) {
  if (el && el.componentOnReady) {
    return el.componentOnReady();
  }

  return Promise.resolve();
};

var deepReady = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(el) {
    var element, stencilEl;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            element = el;

            if (!element) {
              _context7.next = 10;
              break;
            }

            if (!(element.componentOnReady != null)) {
              _context7.next = 8;
              break;
            }

            _context7.next = 5;
            return element.componentOnReady();

          case 5:
            stencilEl = _context7.sent;

            if (!(stencilEl != null)) {
              _context7.next = 8;
              break;
            }

            return _context7.abrupt("return");

          case 8:
            _context7.next = 10;
            return Promise.all(Array.from(element.children).map(deepReady));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function deepReady(_x10) {
    return _ref7.apply(this, arguments);
  };
}();

var setPageHidden = function setPageHidden(el, hidden) {
  if (hidden) {
    el.setAttribute('aria-hidden', 'true');
    el.classList.add('ion-page-hidden');
  } else {
    el.hidden = false;
    el.removeAttribute('aria-hidden');
    el.classList.remove('ion-page-hidden');
  }
};

var setZIndex = function setZIndex(enteringEl, leavingEl, direction) {
  if (enteringEl !== undefined) {
    enteringEl.style.zIndex = direction === 'back' ? '99' : '101';
  }

  if (leavingEl !== undefined) {
    leavingEl.style.zIndex = '100';
  }
};

var getIonPageElement = function getIonPageElement(element) {
  if (element.classList.contains('ion-page')) {
    return element;
  }

  var ionPage = element.querySelector(':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs');

  if (ionPage) {
    return ionPage;
  } // idk, return the original element so at least something animates and we don't have a null pointer


  return element;
};

export { LIFECYCLE_WILL_ENTER as L, LIFECYCLE_DID_ENTER as a, LIFECYCLE_WILL_LEAVE as b, LIFECYCLE_DID_LEAVE as c, LIFECYCLE_WILL_UNLOAD as d, deepReady as e, getIonPageElement as g, lifecycle as l, setPageHidden as s, transition as t };